import {
  FilterGroupDto,
  PaginatedSMSMessagesDto,
  PaginatedUsersDto,
  SMSMessageDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const smsMessageRequests = {
  getSMSMessages: EndpointDefinition.get<
    PaginatedSMSMessagesDto,
    {
      subjectIds?: string;
      onlyUnassignedMessages?: boolean;
      directionType?: 'incoming' | 'outgoing';
      searchTerm?: string;
      searchTermType?: 'string' | 'subjectId' | 'number';
      'page-start'?: number;
      'page-size'?: number;
    }
  >({
    name: 'getSMSMessages',
    route: '/sms',
  }),

  getSMSFilters: EndpointDefinition.get<FilterGroupDto, { named?: string }>({
    name: 'getSMSFilters',
    route: '/sms/filters',
  }),

  assignSMSMessage: EndpointDefinition.patch<
    SMSMessageDto,
    {},
    {
      id: number;
    }
  >({
    name: 'assignSMSMessage',
    route: '/sms/:id',
  }),

  unassignSMSMessage: EndpointDefinition.delete<
    SMSMessageDto,
    {
      id: number;
    }
  >({
    name: 'unassignSMSMessage',
    route: '/sms/:id',
  }),

  getMembersForSMSAssignment: EndpointDefinition.get<
    PaginatedUsersDto,
    {
      id: number;
    }
  >({
    name: 'getMembersForSMSAssignment',
    route: '/sms/:id/members',
  }),
};
